import script from "./SourceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceSettings.vue?vue&type=script&setup=true&lang=js"

import "./SourceSettings.vue?vue&type=style&index=0&id=edc41f78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edc41f78"]])

export default __exports__